module.exports = __webpack_public_path__ + "media/images/flags/tc-b2c3af50ca57b933486aa4140ed53d2a.svg";